module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Dedication-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "frontmatter dedication",
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("Dedicated to the memory of")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('em', [_vm._v("John F. Marks, 1936–2017")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('em', [_vm._v("Friend and sensei")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 69
// module chunks = 0